export default "__VITE_ASSET__6b42ad9b__"